<template>
    <v-list class="pa-0">
        <v-list-item-group
            v-if="!loading"
            v-model="selection"
            :class="{ 'flex flex-col gap-2': !loading }"
            mandatory
        >
            <v-list-item
                v-for="item in paymentMethods"
                :key="item.id"
                :value="item"
                two-line
                class="v-sheet--outlined soli-round"
                ><template v-slot:default="{ active }">
                    <v-list-item-avatar>
                        <v-img
                            :src="`/PaymentIcons/${item.brand}.webp`"
                            :alt="item.brand"
                        />
                    </v-list-item-avatar>

                    <v-list-item-content class="text-align-start ml-2 py-0">
                        <v-list-item-title>{{ item.last4 }}</v-list-item-title>
                        <v-list-item-subtitle v-if="item.name">{{
                            item.name
                        }}</v-list-item-subtitle>
                        <v-list-item-subtitle>{{
                            item.exp
                        }}</v-list-item-subtitle>
                    </v-list-item-content>
                    <v-list-item-action>
                        <div class="flex align-center">
                            <v-list-item-subtitle
                                v-if="item.default"
                                class="mr-3"
                                >Default</v-list-item-subtitle
                            ><v-icon color="accent">{{
                                active
                                    ? "radio_button_checked"
                                    : "radio_button_unchecked"
                            }}</v-icon>
                        </div>
                    </v-list-item-action></template
                >
            </v-list-item>
        </v-list-item-group>
        <v-list-item v-if="loading">
            <v-skeleton-loader
                type="list-item-avatar-two-line"
                :class="[$vuetify.breakpoint.smAndUp ? 'w-3/4' : 'w-full']"
            ></v-skeleton-loader>
        </v-list-item>
    </v-list>
</template>

<script>
export default {
    props: {
        user: {
            type: Object,
            default: () => {},
        },
    },
    data() {
        return {
            paymentMethods: [],
            selection: null,
            loading: false,
        };
    },
    methods: {
        getPaymentMethods() {
            if (!this.user) return null;
            this.loading = true;
            axios
                .get(`api/stripe/payment-methods/${this.user.id}`)
                .then((resp) => {
                    this.paymentMethods = resp.data;
                    this.selection = resp.data.find((e) => e.default);
                    this.loading = false;
                    this.$emit("stripeLoaded");
                });
        },
    },
    created() {
        this.getPaymentMethods();
    },
    watch: {
        selection(val) {
            this.$emit("input", val);
        },
    },
};
</script>
